export const GEMINI_MODEL_FLASH = "gemini-2.5-flash";
